import { useEffect, useState } from 'react';
import Modal from '../../shared/components/Modal';
import { REGISTER_VOUCHER } from '../../network/Endpoint';
import { FormattedMessage, useIntl } from 'react-intl';

const VoucherRegistrationModal = ({ showVoucherRegistrationModal, closeVoucherRegistrationModal, accountId }) => {
  const intl = useIntl();
  const [formData, setFormData] = useState({
    accountId: '',
    voucherCode: '',
  });

  const handleFormData = (e) => {
    setFormData({
      ...formData, // 기존 값들 유지
      [e.target.name]: e.target.value,
    });
  };

  const submit = async (e) => {
    e.preventDefault();
    if (formData.voucherCode === '') {
      alert(intl.formatMessage({ id: 'alert.voucher.empty' }));
      return;
    }
    if (window.confirm(intl.formatMessage({ id: 'confirm.voucher.register' }))) {
      const body = {
        accountId: parseInt(accountId),
        voucherCode: formData.voucherCode,
      };
      await REGISTER_VOUCHER(body)
        .then(async (res) => {
          if (res.data.statusResponse.code === 'M0001') { // M0001: 성공
            closeVoucherRegistrationModal();
            alert(intl.formatMessage({ id: 'voucher.success' }));
          } else if (res.data.statusResponse.code === 'M1101') { // M1101: 학교 계정은 등록 불가
            alert(intl.formatMessage({ id: 'voucher.error.school' }));
          } else if (res.data.statusResponse.code === 'M1102') { // M1102: A로 시작하지 않는 이용권 코드
            alert(intl.formatMessage({ id: 'voucher.error.invalid' }));
          } else if (res.data.statusResponse.code === 'M1103') { // M1103: 존재하지 않는 이용권
            alert(intl.formatMessage({ id: 'voucher.error.notexist' }));
          } else if (res.data.statusResponse.code === 'M1104') { // M1104: 등록 만료된 이용권
            alert(intl.formatMessage({ id: 'voucher.error.expired' }));
          } else if (res.data.statusResponse.code === 'M1105') { // M1105: 사용 중인 이용권
            alert(intl.formatMessage({ id: 'voucher.error.inuse' }));
          } else if (res.data.statusResponse.code === 'M0003') { // M0003: 중복 등록 불가
            alert(intl.formatMessage({ id: 'voucher.error.duplicate' }));
          } else if (res.data.statusResponse.code === 'M0007') { // 사용 기록이 있어서 재사용까지 기간이 남음.
            alert(intl.formatMessage({ id: 'voucher.error.waitperiod' }, {
              lastDate: res.data.lastRegistrationDate,
              remainingDays: res.data.remainingDays,
              availableDate: res.data.availableDate
            }));
          } else if (res.data.statusResponse.code === 'M0011') { // 1회성 등록 상품의 이용권
            alert(intl.formatMessage({ id: 'voucher.error.onetime' }));
          }
        })
        .catch(async (error) => {
          console.log('REGISTER_VOUCHER error: ', error);
        });
    }
  };

  useEffect(() => {
    if (showVoucherRegistrationModal) {
      setFormData({
        accountId: accountId,
        voucherCode: '',
      });
    }
  }, [showVoucherRegistrationModal]);

  return (
    <Modal show={showVoucherRegistrationModal} closeModal={closeVoucherRegistrationModal} zIndex={100}>
      <form onSubmit={(e) => submit(e)} className="min-w-[300px]">
        <div><FormattedMessage id="voucher.code" /></div>
        <div className="mt-[10px] lg:mt-[12px]">
          <input className="w-[100%] border border-[#d9dce1] rounded-md p-[4px] lg:p-[10px]"
                 type="text"
                 name="voucherCode"
                 placeholder={intl.formatMessage({ id: 'placeholder.voucher' })}
                 value={formData.voucherCode || ''}
                 onChange={handleFormData}/>
        </div>
        <div className="mt-[20px] lg:mt-[26px]">
          <div>
            <button type={'submit'} className="w-[100%] bg-[#005ade] text-[#ffffff] rounded-md p-[4px] lg:p-[10px]">
              <FormattedMessage id="registration.button" />
            </button>
          </div>
        </div>
      </form>
    </Modal>
  );
};

export default VoucherRegistrationModal;
